import AotcScan from './AotcScan'

export default AotcScan